import { useEffect, useState } from 'react'

export default function useLocalStorage(key, initValue) {
    const [state, setState] = useState(() => {
        const value = localStorage.getItem(key)
        if (value !== null) {
            return JSON.parse(value)
        }

        localStorage.setItem(key, JSON.stringify(initValue))
        return initValue
    })

    useEffect(() => {
        localStorage.setItem(key, JSON.stringify(state))
        
        // Dispatch custom event to notify other components using the same key
        window.dispatchEvent(new CustomEvent('localStorageChange', {
            detail: { key, value: state }
        }))
    }, [key, state])

    useEffect(() => {
        const listenStorageChange = () => {
            const value = localStorage.getItem(key)
            if (value !== null) {
                setState(JSON.parse(value))
            }
        }

        const listenCustomStorageChange = (event) => {
            // Only respond to changes for our specific key
            if (event.detail && event.detail.key === key) {
                setState(event.detail.value)
            }
        }

        // Listen for both cross-tab storage changes and same-tab custom events
        window.addEventListener('storage', listenStorageChange)
        window.addEventListener('localStorageChange', listenCustomStorageChange)
        
        return () => {
            window.removeEventListener('storage', listenStorageChange)
            window.removeEventListener('localStorageChange', listenCustomStorageChange)
        }
    }, [key, initValue])

    return [state, setState]
}
